import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../../components/ui/dialog';
import { DemoDetailBody } from './DemoDetailPage';

/** Full demo record in a large modal — opened from any demo table row. */
export default function DemoDetailModal({ demoId, readOnly = false, onClose, onChanged }) {
  return (
    <Dialog open={!!demoId} onOpenChange={(o) => { if (!o) onClose?.(); }}>
      <DialogContent className="max-w-6xl max-h-[85vh] overflow-hidden flex flex-col" data-testid="demo-detail-modal">
        <DialogHeader className="sr-only">
          <DialogTitle className="text-base">Demo details</DialogTitle>
          <DialogDescription className="text-[11px] text-slate-500">Feedback, alignment and outcome for this demo.</DialogDescription>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto pr-1">
          {demoId && (
            <DemoDetailBody demoId={demoId} forcedRo={readOnly} inModal onClose={onClose} onChanged={onChanged} />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
